import { t } from "@redotech/redo-i18n";
import { MetafieldMatchType } from "@redotech/redo-return-core-common/condition-options";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  productVariantMetafieldFromModel,
  validateProductVariantMetafieldCondition,
  type ProductVariantMetafieldState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_VARIANT_METAFIELD = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ProductVariantMetafieldState>
  >,
): ConditionType<
  ProductVariantMetafieldState,
  Condition.ProductVariantMetafield
> => ({
  name: CONDITION_NAMES[Condition.PRODUCT_VARIANT_METAFIELD],
  description(state) {
    return t("Metafield: {{metafield}}", {
      metafield: `${state.namespace}.${state.key}`,
    });
  },
  Details(props: ConditionTypeDetailsProps<ProductVariantMetafieldState>) {
    return React.createElement(Details, props);
  },
  empty: {
    namespace: "",
    key: "",
    comparison: MetafieldMatchType.EXACT,
    value: "",
  },
  fromModel(model: Condition.ProductVariantMetafield) {
    return productVariantMetafieldFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PRODUCT_VARIANT_METAFIELD, ...state };
  },
  valid(state) {
    return validateProductVariantMetafieldCondition(state).valid;
  },
});
